import React from 'react';
import { ArrowRight, Shield, TrendingUp } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const HeroSection = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const goToForm = () => {
    navigate('/form?source=pixel2');
  };

  return (
    <section id="hero" className="hero-section">
      <div className="islamic-pattern"></div>
      <div className="hero-content hero-content-centered">
        <div className="hero-left">
          <div className="hero-badge">
            <Shield size={20} />
            <span>{t.heroBadge}</span>
          </div>
          
          <h1 className="hero-title">
            {t.heroTitle}
          </h1>
          
          <p className="hero-description">
            {t.heroDescription}
          </p>

          <div className="hero-stats-mini">
            <div className="stat-mini">
              <TrendingUp size={24} className="stat-icon" />
              <div>
                <div className="stat-value">$10.4M+</div>
                <div className="stat-label">{t.returnedToClients}</div>
              </div>
            </div>
            <div className="stat-mini">
              <Shield size={24} className="stat-icon" />
              <div>
                <div className="stat-value">2000+</div>
                <div className="stat-label">{t.successfulCases}</div>
              </div>
            </div>
            <div className="stat-mini">
              <Shield size={24} className="stat-icon" />
              <div>
                <div className="stat-value">80+</div>
                <div className="stat-label">{t.countriesWorld}</div>
              </div>
            </div>
          </div>

          <div className="hero-cta">
            <button onClick={goToForm} className="btn-primary btn-large">
              {t.freeConsultation}
              <ArrowRight size={20} />
            </button>
            <button onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })} className="btn-secondary btn-large">
              {t.ourServices}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
